import { render } from "./SHomeView.vue?vue&type=template&id=71a0b766"
import script from "./SHomeView.vue?vue&type=script&lang=js"
export * from "./SHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__